import React, { useContext, useState } from "react";
import { Button, Typography, CircularProgress } from "@mui/material";
import StyledTextField from "../../../common/StyledComponents/StyledTextField";
import AlertModal from "../../../common/alertModal/AlertModal";
import "../index.css";
import { AuthContext } from "../../../../context/AuthContext";

const SchoolForm = ({ handleSubmit }) => {
  const [formData, setFormData] = useState({
    school_name: "",
    number_of_teachers: "",
    number_of_students: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setStatus } = useContext(AuthContext);

  const [alert, setAlert] = useState({
    open: false,
    title: "",
    message: "",
    type: "success", // 'success' or 'error'
  });

  const validate = () => {
    const newErrors = {};
    if (!formData.school_name.trim()) newErrors.school_name = "School Name is required.";
    if (formData.number_of_teachers && isNaN(formData.number_of_teachers)) {
      newErrors.number_of_teachers = "Number of Teachers must be a valid number.";
    }
    if (formData.number_of_students && isNaN(formData.number_of_students)) {
      newErrors.number_of_students = "Number of Students must be a valid number.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      try {
        const result = await handleSubmit(formData);
        if (result.success) {
          const userStatus = result.status;
          if (userStatus) {
            setStatus(userStatus);
          }
          setAlert({
            open: true,
            title: "Success",
            message: result.message,
            type: "success",
          });
        } else {
          setAlert({
            open: true,
            title: "Error",
            message: result.message || "Unexpected error occurred.",
            type: "error",
          });
        }
      } catch (error) {
        setAlert({
          open: true,
          title: "Error",
          message: error.response?.data?.message || "An unexpected error occurred. Please try again.",
          type: "error",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <form onSubmit={onSubmit} className="profile-form">
        <Typography className="profile-form-title">
          You are creating a <strong>school</strong> account.
        </Typography>
        <StyledTextField
          label="School Name"
          name="school_name"
          value={formData.school_name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          error={!!errors.school_name}
          helperText={errors.school_name}
          required
        />
        <StyledTextField
          label="Number of Teachers"
          name="number_of_teachers"
          value={formData.number_of_teachers}
          onChange={handleChange}
          type="number"
          fullWidth
          margin="normal"
          error={!!errors.number_of_teachers}
          helperText={errors.number_of_teachers}
        />
        <StyledTextField
          label="Number of Students"
          name="number_of_students"
          value={formData.number_of_students}
          onChange={handleChange}
          type="number"
          fullWidth
          margin="normal"
          error={!!errors.number_of_students}
          helperText={errors.number_of_students}
        />
        <Typography className="note">
          - Please provide accurate numbers for teachers and students as this will determine the cost of this service.
        </Typography>
        <Typography className="note">Fields marked with (*) are required.</Typography>
        <Button
          type="submit"
          className="primary-button"
          fullWidth
          sx={{ marginTop: "20px", padding: "10px" }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
        </Button>
      </form>

      <AlertModal
        open={alert.open}
        onClose={() => {
          setAlert((prev) => ({ ...prev, open: false }));
          if (alert.type === "success") {
            window.location.href = "/payment";
          }
        }}
        title={alert.title}
        message={alert.message}
        type={alert.type}
      />
    </>
  );
};

export default SchoolForm;
